import { Link } from 'react-router-dom';

export default function InheritedApartmentsHero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/2f4001838defffe0a1eb0b4ecb4bbd42.jpg"
          alt="Inherited apartment building"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-32 text-center">
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
          Selling an Inherited
          <span className="block text-orange-500 mt-2">Apartment Building?</span>
        </h1>
        
        <p className="text-xl md:text-2xl text-white/90 mb-12 max-w-3xl mx-auto leading-relaxed">
          We understand the complexities of inherited properties. Get a fair cash offer and avoid the stress of probate, repairs, and tenant management.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a
            href="#get-offer"
            className="whitespace-nowrap px-8 py-4 bg-orange-600 text-white text-lg font-semibold rounded-lg hover:bg-orange-700 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer"
          >
            Get Your Fair Cash Offer
          </a>
          <a
            href="#how-it-works"
            className="whitespace-nowrap px-8 py-4 bg-white/10 backdrop-blur-sm text-white text-lg font-semibold rounded-lg hover:bg-white/20 transition-all duration-300 border-2 border-white/30 cursor-pointer"
          >
            See How It Works
          </a>
        </div>

        {/* Trust Indicators */}
        <div className="mt-16 flex flex-wrap justify-center gap-8 text-white/80">
          <div className="flex items-center gap-2">
            <i className="ri-shield-check-line text-2xl text-orange-500"></i>
            <span className="text-sm md:text-base">Handle Probate Issues</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-group-line text-2xl text-orange-500"></i>
            <span className="text-sm md:text-base">Multiple Heirs Welcome</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-home-smile-line text-2xl text-orange-500"></i>
            <span className="text-sm md:text-base">Buy in Any Condition</span>
          </div>
        </div>
      </div>
    </section>
  );
}
